import React, { useState, useEffect } from 'react';
import { useForm } from 'hooks';
import { FormGroup, required, SubmitButton } from 'components/common/Forms';
import { NotificationManager } from 'react-notifications';
import { Page} from 'components/common';
import { track, Errors } from 'react-redux-form';
import { find, filter } from 'lodash';
import shortid from 'shortid';
import { Button } from 'reactstrap';

export const Pricing = ({
  item,
  onBack,
  client,
  url = 'installers',
  readOnly,
  ...props
}) => {

  const [installers, setInstallers] = useState([]);
  const [installer, setInstaller] = useState(null);
  const [types, setTypes] = useState([]);
  const [maybeComplete, setMaybeComplete] = useState(true);

  const { 
    Form,
    value,
    store,
    Control,
    model,
    actions,
    dispatch,
    setValue,
    load,
    loaded,
    setRefreshToken
  } = useForm([]);

  const fetchInstallers = async () => {
    const installers = await client.get('installers').get('data');
    setInstallers(installers.map(i => ({
      ...i,
      'pricing' : i.pricing.map(p => ({'key':shortid(),...p})),
    })));
  };

  const fetchJobtypes = async () => {
    const jobtypes = await client.get('options?job_types').get('data');
    setTypes(jobtypes.job_types);
  };

  useEffect(() => {
    fetchInstallers();
    fetchJobtypes();
  }, []);

  async function onSubmit(data) {
    try {
      if( installer == undefined || data == {})
          return 

      data = Object.assign(installer, data);

      const replaceTextFn = (i) => (
          {
            ...i,
            'installation_type': find(types, o =>
              o.text === i.installation_type_text
            ).value
          }
      );

      const replaceInstallText = {
        ...data, 
        'pricing': data.pricing.map(replaceTextFn),
      };

      const duplicate = ([h,...t],s) => (
         h === undefined ? false : (
          s.has(h.installation_type_text + h.status) ? true : ( 
            duplicate(t,s.add(h.installation_type_text + h.status))
          )
        )
      )
      
      if(duplicate(data.pricing, new Set())) {
        throw "You have multiple Pricing entries for the same job type"
      }

      await client.put(url + "/" + installer.id, replaceInstallText);
      NotificationManager.success('Saved successfully');
      //      setTimeout(() => window.location.reload(),500);
    } catch(err) {
      if( err.message)
        err = err.message
      NotificationManager.error(err);
    } finally {
      dispatch(actions.setPending('local', false));
    }
  }

  return (
    <Page title="Pricing" className="container">
      <div className='d-flex'>
        {maybeComplete ?
          <Button className='btn-info ml-2'> Complete</Button> :
          <span 
            className='text-primary mt-2 ml-2'
            onClick={() => setMaybeComplete(!maybeComplete)}
            style={{
              cursor: 'pointer'
            }}
          >
            Complete 
          </span>
        }
        {maybeComplete ?
          <span 
            className='text-primary mt-2 ml-2'
            onClick={() => setMaybeComplete(!maybeComplete)}
            style={{
              cursor: 'pointer'
            }}
          > 
            Incomplete
          </span> :
          <Button className='btn-info ml-2'> Incomplete </Button> 
        }
      </div>
      <Form
        onSubmit={onSubmit}
      >
        <FormGroup label="Installer" model=".installer">
          <Control.select disabled={readOnly} model=".installer" onChange={
            e => {
              const installer = find(installers, i => i.id == e.target.value);
              dispatch(actions.setInitial('local'));
              setInstaller(installer);
              if (installer && installer.pricing) {
                dispatch(actions.change('local.pricing',[]));
                installer.pricing.map(e => dispatch(actions.push('local.pricing', e)));
              } else if(typeof installer === 'undefined') {
                dispatch(actions.change('local.pricing',[]));
              }
            }
          }>
            <option />
            {installers.map(i => (
              <option key={i.id} value={i.id}>
                {i.name}
              </option>
            ))}
          </Control.select>
        </FormGroup>
        <br/>
        <table className="table">
          <thead>
            <tr>
              <th>{installer ? installer.name : ''}</th>
              <th>Hard-Wired</th>
              <th>OBD</th>
              <th>Battery</th>
              <th>Trailer</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            {store.getState().local.pricing && store.getState().local.pricing.map((p,i_p) => {
            if (p.status != (maybeComplete ? 60 : 50))
              return ''
            return (
              <tr>
                <th>
                  <FormGroup model={track('local.pricing[].installation_type_text',{'key':p.key})}>
                    <Control.select 
                      readOnly={readOnly}
                      model={track('local.pricing[].installation_type_text',{'key':p.key})}
                      validators={{
                        required,
                      }}
                    >
                      <option/>
                      {types.map(i => (
                        <option key={i.id} value={i.id}>
                          {i.text}
                        </option>
                      ))}
                    </Control.select>
                  </FormGroup>
                </th>
                <th>
                  <span>
                    £
                    <Control.input
                      className='ml-1'
                      readOnly={readOnly}
                      model={ track('local.pricing[].hardwired',{'key':p.key}) }
                      type="number" 
                      style={{
                        width:60
                      }}
                      updateOn="blur"
                      validators={{
                        required,
                      }}
                    />
                    <Errors
                      model={ track('local.pricing[].hardwired',{'key':p.key}) }
                      messages={{
                        required: 'Enter a price',
                        invalid: (val) => `${val} is not a valid number.`,
                      }}
                    />
                  </span>
                </th>
                <th>
                  <span>
                    £
                    <Control.input
                      className='ml-1'
                      readOnly={readOnly}
                      model={ track('local.pricing[].OBD',{'key':p.key}) }
                      type="number" 
                      style={{
                        width:60
                      }}
                      updateOn="blur"
                      validators={{
                        required,
                      }}
                    />
                    <Errors
                      model={ track('local.pricing[].OBD',{'key':p.key}) }
                      messages={{
                        required: 'Enter a price',
                        invalid: (val) => `${val} is not a valid number.`,
                      }}
                    />
                  </span>
                </th>
                <th>
                  <span>
                    £
                    <Control.input
                      className='ml-1'
                      readOnly={readOnly}
                      model={ track('local.pricing[].battery',{'key':p.key}) }
                      type="number" 
                      style={{
                        width:60
                      }}
                      updateOn="blur"
                      validators={{
                        required,
                      }}
                    />
                    <Errors
                      model={ track('local.pricing[].battery',{'key':p.key}) }
                      messages={{
                        required: 'Enter a price',
                        invalid: (val) => `${val} is not a valid number.`,
                      }}
                    />
                  </span>
                </th>
                <th>
                  <span>
                    £
                    <Control.input
                      className='ml-1'
                      readOnly={readOnly}
                      model={ track('local.pricing[].trailer',{'key':p.key}) }
                      type="number" 
                      style={{
                        width:60
                      }}
                      updateOn="blur"
                      validators={{
                        required,
                      }}
                    />
                    <Errors
                      model={ track('local.pricing[].trailer',{'key':p.key}) }
                      messages={{
                        required: 'Enter a price',
                        invalid: (val) => `${val} is not a valid number.`,
                      }}
                    />
                  </span>
                </th>
                <th>
                  <Button 
                    className='btn-danger'
                    onClick={() => {
                      dispatch(actions.remove('local.pricing', i_p));
                    }}
                  > 
                    Delete
                  </Button>
                </th>
              </tr>
            )
            })}
          </tbody>
        </table>
        {installer ? 
        <div className='d-flex'>
          <div className='ml-auto'/>
          { store.getState().forms.local.$form.touched ? 
            <div className='mr-2 font-weight-bold text-danger'>
              Unsaved changes <div className='fa fa-exclamation-circle'/>
            </div> : ''
          }
          <Button 
            className='btn-info mr-2'
            onClick={e => dispatch(actions.push('local.pricing', {
              'key':shortid(),
              'OBD': "0",
              'battery' : "0",
              'hardwired' : "0",
              'trailer' : "0",
              'status'  : maybeComplete ? '60' : '50'
            }))}
          >
            Add New
          </Button>
          <SubmitButton className='ml-2 mr-2 btn-success'>Save</SubmitButton>
        </div> : ''}
      </Form>
    </Page>
  )
};

export default Pricing;



// WEBPACK FOOTER //
// ./src/pages/Pricing.jsx